module.exports = __webpack_public_path__ + "img/premium_01.1ac01958.png";